import { render, staticRenderFns } from "./ArchiveActionPlanModal.vue?vue&type=template&id=60743668&"
import script from "./ArchiveActionPlanModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveActionPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports